import { Component, OnInit } from '@angular/core';
import { UserService } from "../../_services/generatedServices";
import { OrganizationSubscriptionViewModel, OrganizationViewModel, UserSubscriptionViewModel } from "../../_models/generatedModels";
import { AddCardComponent } from "../../organization/admin/settings/billing/add-card.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddUserSubscriptionComponent } from "./addusersubscription.component";
import { AuthenticationService } from "../../_services/authentication.service";
import { SettingsProvider } from "../../_services/settingsProvider.service";

@Component({
  selector: 'bxl-user-subscription',
  templateUrl: 'user-subscription.component.html',
})
export class UserSubscriptionComponent implements OnInit {
  initialized = false;
  userSubscription: UserSubscriptionViewModel;
   subscription: OrganizationSubscriptionViewModel;

  constructor(private userService: UserService, public settings: SettingsProvider, private modalService: NgbModal, public auth: AuthenticationService) { }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.userService.getUserSubscription().subscribe((result) => {
      this.userService.getStripeSubscriptionForUser().subscribe(subscription => {
        this.userSubscription = result;
        this.subscription = subscription;
        //this.totalSubscriptionPrice = Enumerable.from(this.subscription.items).sum(x => x.qty * x.unitAmount);
        this.initialized = true;
      });
    });
  }

  public addCard() {
    const modalRef = this.modalService.open(AddUserSubscriptionComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static'
    });
    modalRef.componentInstance.update = true;
    modalRef.result.then(
      (subscription: UserSubscriptionViewModel) => {
         this.userSubscription = subscription;
      },
      reason => {}
    );
  }

  public addSubscription() {
    const modalRef = this.modalService.open(AddUserSubscriptionComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static'
    });
    modalRef.componentInstance.update = false;
    modalRef.result.then(
      (company: OrganizationViewModel) => {
        this.getData();
      },
      reason => {}
    );
  }
}
